<div class="container-fluid dashboard-topbard">
    <div class="row">
        <!-- <div class="col-lg-2 col-sm-2">
            <div class="dashboard-logo mt-2 white-text pb-2"> <img src="../../../assets/image/admin-logo.png"> </div>
        </div> -->
        <div class="col-lg-12 col-sm-12">
            <button  class="mobile-menu-btn" (click)="Mobile_sidebar_menu_btn()">
                <i class="fas fa-bars"></i>
            </button>

            <ul class="topbar-menu float-right mt-3">
                <li>
                    
                    <div class="support"><img src="assets/image/icon/support-icon.png" class="mr-1"> 1800 0000 9998</div>
                    
                </li>
                <!-- 
                    <li>
                        <a href="#">
                            <div class="notification"><span>1</span><i class="fas fa-bell"></i></div>
                        </a>
                    </li> 
                <li class="ml-3"> | </li>
                -->
                <li class="ml-3"><i class="fas fa-user"></i> Welcome {{username}}</li>
                <li class="ml-2 mr-2"> | </li>
                <li class="dashboard-dropdown-link"><a href="javascirpt:void(0);"> <i class="fas fa-user-cog"></i> My Account</a>

                    <ul class="dashboard-dropdown z-index-top">
                        <li><a [routerLink]="['/myprofile']"><i class="far fa-user"></i> Profile</a></li>
                        <li><a [routerLink]="['/changepassword']"> <i class="fas fa-unlock-alt"></i> Change Password</a></li>
                        <li><a [routerLink]="['/logout']"><i class="fas fa-sign-out-alt"></i> Logout</a></li>
                    </ul>

                </li>

            </ul>
        </div>
    </div>
</div>
